/* tslint:disable */
/* eslint-disable */
/**
 * Unnamed Galvyn API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AcceptInvite,
  ApiErrorResponse,
  FormResultForNullAndAcceptInviteError,
  FormResultForNullAndResetPasswordError,
  FormResultForNullAndSetPasswordErrors,
  GetInvite,
  MeSchema,
  ResetPasswordRequest,
  SetPasswordRequest,
  SettingsSchema,
  UpdateMeRequest,
  VerifyResetCodeResponse,
} from '../models/index';

export interface AcceptInviteRequest {
    uuid: string;
    AcceptInvite?: AcceptInvite;
}

export interface GetInviteCommonRequest {
    uuid: string;
}

export interface ResetPasswordOperationRequest {
    code: string;
    ResetPasswordRequest?: ResetPasswordRequest;
}

export interface ResetPasswordByUuidRequest {
    uuid: string;
    ResetPasswordRequest?: ResetPasswordRequest;
}

export interface SetPasswordOperationRequest {
    SetPasswordRequest?: SetPasswordRequest;
}

export interface UpdateMeOperationRequest {
    UpdateMeRequest?: UpdateMeRequest;
}

export interface VerifyCodeRequest {
    code: string;
}

export interface VerifyUuidRequest {
    uuid: string;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     */
    async acceptInviteRaw(requestParameters: AcceptInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndAcceptInviteError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling acceptInvite().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/frontend/invite/{uuid}/accept`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['AcceptInvite'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async acceptInvite(requestParameters: AcceptInviteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndAcceptInviteError> {
        const response = await this.acceptInviteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInviteCommonRaw(requestParameters: GetInviteCommonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetInvite>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling getInviteCommon().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/invite/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getInviteCommon(requestParameters: GetInviteCommonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetInvite> {
        const response = await this.getInviteCommonRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getMeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<MeSchema>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/common/me`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getMe(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<MeSchema> {
        const response = await this.getMeRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getSettingsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SettingsSchema>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/common/settings`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async getSettings(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SettingsSchema> {
        const response = await this.getSettingsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Generate the openapi definition for the admin page
     * Generate the openapi definition for the admin page
     */
    async openapiAdminRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/admin.json`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate the openapi definition for the admin page
     * Generate the openapi definition for the admin page
     */
    async openapiAdmin(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openapiAdminRaw(initOverrides);
    }

    /**
     * Generate the openapi definition for the common
     * Generate the openapi definition for the common
     */
    async openapiAuthRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/auth.json`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate the openapi definition for the common
     * Generate the openapi definition for the common
     */
    async openapiAuth(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openapiAuthRaw(initOverrides);
    }

    /**
     * Generate the openapi definition for the club admin page
     * Generate the openapi definition for the club admin page
     */
    async openapiClubAdminRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-admin.json`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate the openapi definition for the club admin page
     * Generate the openapi definition for the club admin page
     */
    async openapiClubAdmin(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openapiClubAdminRaw(initOverrides);
    }

    /**
     * Generate the openapi definition for the club member page
     * Generate the openapi definition for the club member page
     */
    async openapiClubMemberRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/club-member.json`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate the openapi definition for the club member page
     * Generate the openapi definition for the club member page
     */
    async openapiClubMember(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openapiClubMemberRaw(initOverrides);
    }

    /**
     * Generate the openapi definition for the common
     * Generate the openapi definition for the common
     */
    async openapiCommonRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/common.json`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Generate the openapi definition for the common
     * Generate the openapi definition for the common
     */
    async openapiCommon(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.openapiCommonRaw(initOverrides);
    }

    /**
     */
    async resetPasswordRaw(requestParameters: ResetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndResetPasswordError>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling resetPassword().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/frontend/credential-reset/{code}/reset`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ResetPasswordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async resetPassword(requestParameters: ResetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndResetPasswordError> {
        const response = await this.resetPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async resetPasswordByUuidRaw(requestParameters: ResetPasswordByUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndResetPasswordError>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling resetPasswordByUuid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/frontend/credential-reset/by-uuid/{uuid}/reset`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['ResetPasswordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async resetPasswordByUuid(requestParameters: ResetPasswordByUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndResetPasswordError> {
        const response = await this.resetPasswordByUuidRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async setPasswordRaw(requestParameters: SetPasswordOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FormResultForNullAndSetPasswordErrors>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/frontend/common/me/set-password`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['SetPasswordRequest'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async setPassword(requestParameters: SetPasswordOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FormResultForNullAndSetPasswordErrors> {
        const response = await this.setPasswordRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async updateMeRaw(requestParameters: UpdateMeOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/api/v1/frontend/common/me`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['UpdateMeRequest'],
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateMe(requestParameters: UpdateMeOperationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateMeRaw(requestParameters, initOverrides);
    }

    /**
     */
    async verifyCodeRaw(requestParameters: VerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyResetCodeResponse>> {
        if (requestParameters['code'] == null) {
            throw new runtime.RequiredError(
                'code',
                'Required parameter "code" was null or undefined when calling verifyCode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/credential-reset/{code}`.replace(`{${"code"}}`, encodeURIComponent(String(requestParameters['code']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async verifyCode(requestParameters: VerifyCodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyResetCodeResponse> {
        const response = await this.verifyCodeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async verifyUuidRaw(requestParameters: VerifyUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<VerifyResetCodeResponse>> {
        if (requestParameters['uuid'] == null) {
            throw new runtime.RequiredError(
                'uuid',
                'Required parameter "uuid" was null or undefined when calling verifyUuid().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/api/v1/frontend/credential-reset/by-uuid/{uuid}`.replace(`{${"uuid"}}`, encodeURIComponent(String(requestParameters['uuid']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async verifyUuid(requestParameters: VerifyUuidRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<VerifyResetCodeResponse> {
        const response = await this.verifyUuidRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
